var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};



//////////////////
// WEBPACK FOOTER
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_06/_work/151/s/FrontEnd/node_modules/list.js/src/utils/index-of.js
// module id = 440
// module chunks = 1 5 15 16 25 26 27 28 29 30 31 32 33